import { render, staticRenderFns } from "./H5VerticalNewsVideoList.vue?vue&type=template&id=57b1e838&scoped=true"
import script from "./H5VerticalNewsVideoList.vue?vue&type=script&lang=js"
export * from "./H5VerticalNewsVideoList.vue?vue&type=script&lang=js"
import style0 from "./H5VerticalNewsVideoList.vue?vue&type=style&index=0&id=57b1e838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b1e838",
  null
  
)

export default component.exports